import { render, staticRenderFns } from "./i-image-collection.vue?vue&type=template&id=66720c88&scoped=true&"
import script from "./i-image-collection.vue?vue&type=script&lang=js&"
export * from "./i-image-collection.vue?vue&type=script&lang=js&"
import style0 from "./i-image-collection.vue?vue&type=style&index=0&id=66720c88&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66720c88",
  null
  
)

export default component.exports